import React, { Component } from 'react';
import { Formik } from 'formik';
import {Alert, Button} from 'reactstrap';
import {connect} from 'react-redux'
import {auth, } from '../../redux/AuthActionCreaters';
import Spinner from '../Spinner/Spinner';


const mapStateToProps = (state) => {
    return {
        authLoading: state.authLoading,
        authErrMsg:state.authErrMsg
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        auth: (email,password,mode) => {
            dispatch(auth(email,password,mode))
        }
        
    }
}

class Auth extends Component{
    state={
        mode:"Sign Up"
    }
    onMoodChange=()=>{
        
        this.setState({
            mode:this.state.mode==="Sign Up"?"Login":"Sign Up"
        })
    }
    render(){
        let err=null;
        if(this.props.authErrMsg){
            err= <Alert color="danger">
            {this.props.authErrMsg}
          </Alert>
        }
        let formik=null;
        if(!this.props.authLoading){
            formik= <Formik

            initialValues={
                {
                    email:'',
                    password:'',
                    confirmpassword:''
                }
            }

            onSubmit={
                (values)=>{
                this.props.auth(values.email,values.password,this.state.mode)
            }}

            validate ={(values)=>{
                const errors={}

                if(!values.email){
                    errors.email="Required"
                } else if(!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)){
                    errors.email="invalid email address"
                }
                if(!values.password){
                    errors.password="Required"
                } else if(values.password<=6){
                    errors.password="Password length must be 5"
                }
                if(this.state.mode==="Sign Up"){
                    if(!values.confirmpassword){
                        errors.confirmpassword="Required"
                    } else if(values.password!==values.confirmpassword){
                        errors.confirmpassword="Password not match"
                    }
                }
                

                return errors;
            }}
        >

           {(values)=>(
                <div className="border p-5">
                    <Button className="btn heading d-block w-100 mb-3 text-light" 
                        onClick={this.onMoodChange}>
                        Switch to {this.state.mode==="Sign Up"?"Login":"Sign Up"}
                    </Button>
                    <form onSubmit={values.handleSubmit}>
                        <label htmlFor="email">Email</label><br/>
                        <input type="email" 
                        name="email" 
                        id="email" 
                        className="form-control"
                        onChange={values.handleChange}
                        value={values.values.email}
                        />
                        <span className="text-danger p-1 mb-1">{values.errors.email}</span>
                        <br/>
                        <label htmlFor="password">Password</label><br/>
                        <input type="password" 
                        name="password" 
                        id="password" 
                        className="form-control"
                        onChange={values.handleChange}
                        value={values.values.password}
                        />
                        <span className="text-danger p-1 mb-1">{values.errors.password}</span>
                        <br/>
                        {this.state.mode==="Sign Up"?
                        (<div><label htmlFor="cpassword">Confirm Password</label><br/>
                        <input type="password" 
                        name="confirmpassword" 
                        id="cpassword" 
                        className="form-control"
                        onChange={values.handleChange}
                        value={values.values.confirmpassword}
                        />
                        <span className="text-danger p-1 mb-1">{values.errors.confirmpassword}</span>
                        <br/></div>):null
                        }
                        <button type="submit" className="btn btn-success">{this.state.mode==="Sign Up"?"Sign Up":"Login"}</button>
                    </form>
                </div>
           )}

        </Formik>
        }
        else{
            formik=<Spinner/>
        }
        return(
           
            <div className="container">
                {err}
               {formik}
            </div>
        )
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(Auth);